import React, { Suspense } from "react";
import "dracula-ui/styles/dracula-ui.css";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import { Heading } from "dracula-ui";
import ScrollToTop from "react-scroll-to-top";
import { HelmetProvider } from 'react-helmet-async';
import { useGoogleAnalytics } from "./hooks/useGoogleAnalytics";
import LoadingIcons from "react-loading-icons";
import SEOHelmet from "./Components/SEOHelmet";
import { useServiceWorker } from "./hooks/useServiceWorker";

// Lazy loading das páginas para code splitting
const Search = React.lazy(() => import("./Pages/Search"));
const Results = React.lazy(() => import("./Pages/Result"));
const RankingEstados = React.lazy(() => import("./Pages/RankingEstados"));
const RankingMunicipios = React.lazy(() => import("./Pages/RankingMunicipios"));
const Comparar = React.lazy(() => import("./Pages/Comparar"));
const Agrupar = React.lazy(() => import("./Pages/Agrupar"));
const InversedRankingMunicipios = React.lazy(() => import("./Pages/InversedRankingMunicipios"));

// Componentes de Search diretos
const Ranking = React.lazy(() => import("./Components/Search/Ranking"));
const Diferentes = React.lazy(() => import("./Components/Search/Diferentes"));
const Ascencao = React.lazy(() => import("./Components/Search/Ascencao"));
const Futebol = React.lazy(() => import("./Components/Search/Futebol"));
const Famosos = React.lazy(() => import("./Components/Search/Famosos"));
const Astronomia = React.lazy(() => import("./Components/Search/Astronomia"));
const Pensadores = React.lazy(() => import("./Components/Search/Pensadores"));
const Geeks = React.lazy(() => import("./Components/Search/Geeks"));
const Sugestoes = React.lazy(() => import("./Components/Sugestoes/Sugestoes").then(module => ({ default: module.Sugestoes })));
const Artistas = React.lazy(() => import("./Components/Search/Artistas"));
const Flores = React.lazy(() => import("./Components/Search/Flores"));
const Presidentes = React.lazy(() => import("./Components/Search/Presidentes"));
const PrivacyPolicy = React.lazy(() => import("./Pages/PrivacyPolicy"));
const NotFound = React.lazy(() => import("./Pages/NotFound"));

function App() {
  // Implementa tracking automático de navegação SPA
  useGoogleAnalytics();
  
  // Service Worker para cache e performance
  useServiceWorker();

  return (
    <HelmetProvider>
      <main className="App">
        <SEOHelmet />
        <ScrollToTop 
          style={{width:"45px",backgroundColor:"transparent", boxShadow:"none"}}
          smooth 
          top={500}
          component={<p style={{ fontSize: '30px', marginTop: '5px'}}>🔼</p>} />
        <br></br>
        <Heading style={{fontSize:"2.2em", textAlign: "center", padding: "10px 0 0 0" }}>
          Nomes no Brasil +
        </Heading>
        <Heading size="xs" style={{ textAlign: "center", padding: "0 0 40px 0" }}>
          <small>Com dados do <b>IBGE</b></small>
        </Heading>
        <br></br>
        <br></br>
        <br></br>
      <Suspense fallback={
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <LoadingIcons.Oval stroke="#bd93f9" strokeOpacity={0.8} speed={0.75} />
        </div>
      }>
        <Routes>
          {/* Home page */}
          <Route path="" element={<Search />} />
          
          {/* Páginas específicas dos componentes */}
          <Route path="/ranking" element={<Ranking />} />
          <Route path="/diferentes" element={<Diferentes />} />
          <Route path="/ascencao" element={<Ascencao />} />
          <Route path="/futebol" element={<Futebol />} />
          <Route path="/famosos" element={<Famosos />} />
          <Route path="/astronomia" element={<Astronomia />} />
          <Route path="/pensadores" element={<Pensadores />} />
          <Route path="/geeks" element={<Geeks />} />
          <Route path="/sugestoes" element={<Sugestoes />} />
          <Route path="/artistas" element={<Artistas />} />
          <Route path="/flores" element={<Flores />} />
          <Route path="/presidentes" element={<Presidentes />} />
          
          {/* Outras páginas */}
          <Route path="/results/:pagina/:nome" element={<Results />} />
          <Route path="/nome/:nome" element={<Results />} />
          <Route path="/categoria/:categoria/:nome" element={<Results />} />
          <Route path="/porEstado" element={<RankingEstados />} />
          <Route path="/porMunicipio" element={<RankingMunicipios />} />
          <Route path="/raros" element={<InversedRankingMunicipios />} />
          <Route path="/comparar" element={<Comparar />} />
          <Route path="/agrupar" element={<Agrupar />} />
          
          {/* Política de Privacidade */}
          <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
          
          {/* Página 404 */}
          <Route path="/404" element={<NotFound />} />
          
          {/* Manter compatibilidade com rotas antigas - DEVE FICAR POR ÚLTIMO */}
          <Route path="/:pagina" element={<Search />} />
          <Route path="/:pagina/:callback" element={<Search />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
        <br></br>
        <br></br>
        <br></br>
      </main>
    </HelmetProvider>
  );
}

export default App;
